/*
 *=========================================================================================
 *File Name: sidebarItems.js
 *Description: Sidebar Items list. Add / Remove menu items from here.
 *----------------------------------------------------------------------------------------
 *Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
 *Author: Pixinvent
 *Author URL: http://www.themeforest.net/user/pixinvent
 *==========================================================================================
 */

export default [
	{
		url: "/",
		name: "Accueil",
		slug: "home",
		icon: "HomeIcon",
		roleHasAccess: [1, 2],
		userRoleHasAccess: [211, 221, 251, 141, 131, 161, 171, 191, 181]
	},
	{
		url: "/documents",
		name: "Documents",
		slug: "home",
		icon: "FileTextIcon",
		roleHasAccess: [1, 2],
		userRoleHasAccess: [211, 221, 251]
	},
	{
		url: "/society",
		name: "Clients",
		slug: "society",
		icon: "UsersIcon",
		roleHasAccess: [1],
		userRoleHasAccess: [141, 131, 161, 191, 181]
	},
	{
		url: "/contracts",
		name: "Contrats",
		slug: "contracts",
		icon: "FileTextIcon",
		roleHasAccess: [1],
		userRoleHasAccess: [141, 131, 161, 191, 181]
	},
	{
		url: "/prospects",
		name: "Prospection",
		slug: "prospects",
		icon: "TargetIcon",
		roleHasAccess: [1],
		userRoleHasAccess: [141, 131, 161, 191]
	},
	//{
	//	url: "/tasks",
	//	name: "Tâches",
	//	slug: "tasks",
	//	icon: "ListIcon",
	//	roleHasAccess: [1],
	//	userRoleHasAccess: [131, 161, 191, 171]
	//},
	// {
	// 	url: "/netlink",
	// 	name: "Netlinking",
	// 	slug: "netlink",
	// 	icon: "Share2Icon",
	// 	roleHasAccess: [1, 2],
	// 	userRoleHasAccess: [211, 221, 251, 141, 131, 161, 191]
	// },
{
		name: "Backlinks",
		slug: "backlinks",
		icon: "LinkIcon",
			roleHasAccess: [1, 2],
		userRoleHasAccess: [211, 221, 251, 141, 131, 161, 191],
		submenu: [
			{
				url: "/backlinks-repertoire",
				name: "Backlinks Repertoire",
				slug: "backlinks-repertoire",
			},
			{
				url: "/backlinks-listes",
				name: "Backlinks Listes",
				slug: "backlinks-listes",
			},
		]
		},
	{
		url: "/dns",
		name: "Noms de domaine",
		slug: "dns",
		icon: "ServerIcon",
		roleHasAccess: [1],
		userRoleHasAccess: [131, 161, 191] // A VOIR L'ACCESS CLIENT
	},
	{
		url: "/consultants",
		name: "Gestion de Projet",
		slug: "consultants",
		icon: "TrelloIcon",
		roleHasAccess: [1],
		userRoleHasAccess: [131, 161, 171, 181, 191]
	},
	{
		url: "/providers",
		name: "Prestataires",
		slug: "providers",
		icon: "UserCheckIcon",
		roleHasAccess: [1],
		userRoleHasAccess: [131, 161, 191]
	},
	{
		url: "/purchases",
		name: "Achats",
		slug: "purchase",
		icon: "ShoppingCartIcon",
		roleHasAccess: [1],
		userRoleHasAccess: [131, 161, 191, 181]
	},
	{
		url: "/invoices",
		name: "Facturation",
		slug: "invoices",
		icon: "DollarSignIcon",
		roleHasAccess: [1],
		userRoleHasAccess: [191]
	},
	{
		url: "keyword",
		name: "Keywords",
		slug: "keyword",
		icon: "TrendingUpIcon",
		roleHasAccess: [2],
		userRoleHasAccess: [211, 221, 251],
	},
	{
		url: "report",
		name: "Rapports",
		slug: "report",
		icon: "ClipboardIcon",
		roleHasAccess: [1],

	},
	{
		name: "Analyse SEO",
		slug: "data",
		icon: "TrendingUpIcon",
		roleHasAccess: [1],
		userRoleHasAccess: [191],
		submenu: [
			{
				url: "keyword",
				name: "Keywords",
				slug: "keyword",
			},
			{
				url: "performance",
				name: "Performances",
				slug: "performance",
			},
			{
				url: "exploration",
				name: "Exploration",
				slug: "exploration",
			},
			{
				url: "analyse_semantique",
				name: "Analyse Sémantique",
				slug: "analyse_semantique",
			},
			{
				url: "pagespeed",
				name: "Speed test",
				slug: "pagespeed",
			}
		]
	},
	{
		url: "/generateTemplateSeo",
		name: "Generation de Template",
		slug: "generateTemplateSeo",
		icon: "FileTextIcon",
		roleHasAccess: [1],
		userRoleHasAccess: [141, 131, 161, 191, 181]
	},
	{
		name: "Paramètres",
		slug: "data",
		icon: "SettingsIcon",
		footer: true,
		roleHasAccess: [1],
		userRoleHasAccess: [161, 191],
		submenu: [

			{
				url: "/products",
				name: "Prestations",
				slug: "products",
			},
			{
				url: "/netlink_types",
				name: "Type de Netlinks",
				slug: "netlink_types",
			},
			{
				url: "/netlink-thema",
				name: "Netlinking",
				slug: "netlink-thema",
			},
			{
				url: "/collaborator",
				name: "Collaborateurs",
				slug: "collaborator",
			},
			{
				url: "/contacts",
				name: "Contacts",
				slug: "contacts",
			},
			{
				url: "/logs",
				name: "Logs",
				slug: "logs",
			},
			{
				url: "/prospects_settings",
				name: "Prospection",
				slug: "prospection",
			},
			{
				url: "/exports",
				name: "Exports",
				slug: "exports",
			}
		],
	},
	/*
	 *{
	 *url: "/register",
	 *name: "Inscriptions",
	 *slug: "register",
	 *icon: "LockIcon",
	 *roleHasAccess: [1, 2, 3]
	 *}
	 */
];
